import React from 'react';

import ReactEChartsCore from 'echarts-for-react/lib/core';
import { PieChart } from 'echarts/charts';
import {
    GridComponent,
    LegendComponent,
    TitleComponent,
    TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from 'helpers/utils';
import PropTypes from 'prop-types';

echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    PieChart,
    CanvasRenderer,
    LegendComponent
]);

const SalesBySellerChart = ({ data }) => {
    const chartData = data.map(item => ({
        value: parseFloat(item.value),
        name: item.label
    }));

    const getOptions = () => ({
        color: data.map(item => getColor(item.color)),
        tooltip: {
            trigger: 'item',
            padding: [7, 10],
            backgroundColor: getColor('gray-100'),
            borderColor: getColor('gray-300'),
            textStyle: { color: getColor('dark') },
            borderWidth: 1,
            transitionDuration: 0,
            formatter: params =>
                `<strong>${params.data.name}:</strong> ${params.value.toFixed(1)}%`
        },
        toolbox: {
            show: false
        },
        legend: {
            show: true,
            bottom: 0,
            itemWidth: 10,
            itemHeight: 10,
            textStyle: {
                color: getColor('gray-700'),
                fontSize: 12
            }
        },
        series: [
            {
                type: 'pie',
                radius: ['65%', '80%'],
                avoidLabelOverlap: true,
                itemStyle: {
                    borderWidth: 2,
                    borderColor: getColor('gray-100')
                },
                label: {
                    show: true,
                    position: 'outside',
                    formatter: '{b}: {d}%',
                    textStyle: {
                        fontSize: 12
                    }
                },
                emphasis: {
                    scale: true
                },
                data: chartData
            }
        ]
    });

    return (
        <ReactEChartsCore
            echarts={echarts}
            option={getOptions()}
            style={{ height: 300 }}
        />
    );
};

SalesBySellerChart.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired, // Ej: "32.5%"
            label: PropTypes.string.isRequired,
            color: PropTypes.string.isRequired
        })
    ).isRequired
};

export default SalesBySellerChart;
